// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ac1b028","885":"87971fe5"}[chunkId] + ".chunk.js";
};